var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredentialsSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.594 3.8H9.772l.558-2.22A.465.465 0 0 0 9.875 1h-3.75a.47.47 0 0 0-.455.58l.558 2.22H1.406C.631 3.8 0 4.428 0 5.2v8.4c0 .772.63 1.4 1.406 1.4h13.188c.775 0 1.406-.628 1.406-1.4V5.2c0-.772-.63-1.4-1.406-1.4zm-5.32-1.867-.702 2.8H7.428l-.703-2.8h2.55zM15.064 13.6c0 .257-.21.467-.47.467H1.407a.468.468 0 0 1-.468-.467V5.2c0-.257.21-.467.468-.467h5.056l.146.58c.052.208.24.354.455.354h1.875a.468.468 0 0 0 .454-.354l.146-.58h5.056c.258 0 .469.21.469.467v8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.079 8.816c.318-.334.515-.786.515-1.283 0-1.029-.841-1.866-1.875-1.866a1.873 1.873 0 0 0-1.875 1.866c0 .497.196.949.515 1.283a2.8 2.8 0 0 0-1.453 2.45v1.4c0 .258.21.467.469.467h4.688a.468.468 0 0 0 .468-.466v-1.4a2.8 2.8 0 0 0-1.452-2.45zM3.78 7.533c0-.514.42-.933.938-.933.517 0 .937.419.937.933a.936.936 0 0 1-1.875 0zM6.594 12.2h-3.75v-.933c0-1.03.84-1.867 1.875-1.867 1.034 0 1.875.837 1.875 1.867v.933zM8.938 7.533h2.843a.468.468 0 1 0 0-.933H8.937a.468.468 0 1 0 0 .933zM13.656 8.467H8.937a.468.468 0 1 0 0 .933h4.72a.468.468 0 1 0 0-.933zM13.656 10.333H8.937a.468.468 0 1 0 0 .934h4.72a.468.468 0 1 0 0-.934zM13.656 12.2H8.937a.468.468 0 1 0 0 .933h4.72a.468.468 0 1 0 0-.933z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsSmall);
export default __webpack_public_path__ + "static/media/credentials-small.5beb2db3b2cea3a280375b7246c33b29.svg";
export { ForwardRef as ReactComponent };